




















import { VSelect } from 'vuetify/lib'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-input-select',
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    persistentHint: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    singleLine: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VSelect
  }
})
